import React from 'react';

const Footer = () =>
    <footer className="my-4">
        <span className="text-secondary">© Copyright 2021 </span><a href="https://twitter.com/stevenmcstravog" target="_blank" rel="noreferrer">Steven McStravog</a>
    </footer>

export default Footer;